import React from "react";
import { useParams } from "react-router-dom";
import FailedImg from "../../../images/AnanasSolutionsLogo.webp";

export default function StorePaymentFailed() {
  const { lang } = useParams();

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-[#fff8e8] to-white">
      <section className="w-full max-w-lg text-center p-8">
        {/* Halo doux */}
        <div className="relative mx-auto w-36 sm:w-44 aspect-square">
          <div className="absolute inset-0 rounded-full bg-[#ffefc2] blur-3xl opacity-60" />
          <img
            src={FailedImg}
            alt="Logo Ananas Solutions"
            className="relative z-10 w-full h-full object-contain drop-shadow-md"
          />
        </div>

        {/* Titre cohérent avec la page succès */}
        <h1 className="mt-8 text-3xl font-semibold text-[#8a3a2a]">
          Le paiement n’a pas été complété
        </h1>

        {/* Message doux + premium */}
        <p className="mt-4 text-base leading-relaxed text-[#6b705c]">
          Une erreur est survenue lors du traitement de votre paiement. Aucun
          montant ne sera conservé si la transaction a échoué.
        </p>

        <p className="mt-2 text-sm text-[#8a8f89]">
          Vous pouvez réessayer ou retourner à la boutique.
        </p>

        {/* Bouton harmonisé */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={`/boutique`}
            className="flex items-center justify-center bg-[#fff3af] text-[#3a3a3a] px-6 py-2 rounded-full border border-[#94d3cc] hover:bg-[#fcd34d] transition-all shadow-sm hover:shadow-md sm:w-auto w-full"
          >
            Retourner à la boutique
          </a>
        </div>
      </section>
    </main>
  );
}
